<template>
  <div class="error-404">
    <div class="error-404__content">
      <div class="heart">
        <i class="icon-error fa fa-skull-crossbones fa-5x"></i><br />
        <h1><b>Error 404</b></h1>
        <h3>Page not found</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style lang="scss" scoped>
.error-404 {
  min-height: 58vh;
  &__content {
    @include justify-items-center;
    margin-top: 30% !important;

    .icon-error {
      color: $color-user-busy;
    }

    @keyframes latidos {
      from {
        transform: none;
      }
      50% {
        transform: scale(1.4);
      }
      to {
        transform: none;
      }
    }

    .heart {
      display: inline-block;
      font-size: 15px;
      color: inherit;
      animation: latidos 0.9s infinite;
      transform-origin: center;
    }
  }
}
</style>
